import styled from 'styled-components';

import { device } from '@/styles/helpers';

export const ScGamesSectionPoint = styled.div`
  position: absolute;
  height: 1px;
  top: -72px;

  @media (${device.tablet}) {
    top: -64px;
  }
`;

export const ScFilterGamesContainer = styled.div`
  border-radius: 0px 0px 24px 24px;
`;

export const ScFilterGames = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
  padding: 20px 0 12px;
  min-width: 100%;
  margin: 0 0 12px;
`;

export const ScFilterGamesMob = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: ${({ theme }) => theme.blackColor};
  gap: 16px;
  margin-bottom: 16px;
  padding: 16px 0;
  transition: 0.3s;
`;

export const ScSearchGroup = styled.div`
  display: grid;
  width: max-content;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;

  @media (${device.mobileS}) {
    width: 100%;
    grid-template-columns: auto repeat(2, minmax(0, 1fr));
  }
`;
